import { OrderAdDetailUpdate } from "./order-ad-detail-update.model";

export class CancelOrderRequest {
	id: string | undefined;
	advertiserId: string | undefined;
	otherPayerId: string | undefined;
	requestStatus: string = "cancelled";
	orderAdDetailUpdates: OrderAdDetailUpdate[] = [];
}
